export { JiraWorkManagementIcon } from './icon';
export { JiraWorkManagementLogo } from './logo';
